import { connect } from 'react-redux';
import OrderDetailVendorPage from './order-detail-vendor.presentation';
import {
  setOrderDetailVendorFilter,
  setOrderDetailVendorPaging,
  setOrderDetailVendorSort,
  setOrderDetailVendorSelectedTab,
} from '../../redux/action';
import * as Constant from '../../constant';

const getFilteredOrderDetails = (state) => {
  const filteredOrderDetail = [{
    id: 1,
    containerNo: '00000000000',
    soNo: '',
    blNo: '',
    containerNoOut: 'MSKU2805695',
    soNoOut: '515237.2IS',
    blNoOut: 'MCB651085',
    status: 'Confirmed',
    gateInCdp: '',
    gateOutCdp: '',
    driverName: '',
    truckNo: '',

  }, {
    id: 2,
    containerNo: '00000000000',
    soNo: '',
    blNo: '',
    containerNoOut: 'TRHU1142267',
    soNoOut: '515262.2IS',
    blNoOut: 'MCB655520',
    gateInCdp: '',
    gateOutCdp: '',
    status: 'Confirmed',
    driverName: '',
    truckNo: '',
  }];

  const {
    filters, sortField, sortDirection, selectedTab,
  } = state.uiOrderDetailVendor;

  return filteredOrderDetail.sort((left, right) => {
    if (typeof left[sortField] === 'string') {
      if (sortDirection === Constant.TABLE_SORT_ASCENDING) {
        return left[sortField].localeCompare(right[sortField]);
      }
      return right[sortField].localeCompare(left[sortField]);
    }

    if (sortDirection === Constant.TABLE_SORT_ASCENDING) {
      return left[sortField] - right[sortField];
    }
    return right[sortField] - left[sortField];
  })
    .filter(item => (`${item.containerNo}`).toUpperCase().indexOf(
      filters[Constant.TABLE_FIELD_ORDER_DETAIL_CONTAINER_NO].toUpperCase(),
    ) >= 0)
    .filter(item => item.soNo.toUpperCase().indexOf(
      filters[Constant.TABLE_FIELD_ORDER_DETAIL_SO_NO].toUpperCase(),
    ) >= 0)
    .filter(item => item.blNo.toUpperCase().indexOf(
      filters[Constant.TABLE_FIELD_ORDER_DETAIL_BL_NO].toUpperCase(),
    ) >= 0)
    .filter(item => item.containerNoOut.toUpperCase().indexOf(
      filters[Constant.TABLE_FIELD_ORDER_DETAIL_CONTAINER_NO_OUT].toUpperCase(),
    ) >= 0)
    .filter(item => item.soNoOut.toUpperCase().indexOf(
      filters[Constant.TABLE_FIELD_ORDER_DETAIL_SO_NO_OUT].toUpperCase(),
    ) >= 0)
    .filter(item => item.status.toUpperCase().indexOf(
      filters[Constant.TABLE_FIELD_ORDER_DETAIL_STATUS].toUpperCase(),
    ) >= 0);
};

const getPageFilteredOrderDetails = (state) => {
  const {
    activePage, pageSize,
  } = state.uiOrderDetailVendor;
  const filteredOrderDetail = getFilteredOrderDetails(state);

  if (filteredOrderDetail) {
    const refinedActivePage = activePage || 1;
    const start = Math.min((refinedActivePage - 1) * pageSize,
      filteredOrderDetail.length);
    const end = Math.min(start + pageSize, filteredOrderDetail.length);
    return filteredOrderDetail.slice(start, end);
  }

  return [];
};

const getTotalPage = (state) => {
  const filteredOrderDetail = getFilteredOrderDetails(state);
  const { pageSize } = state.uiOrderDetailVendor;
  const totalData = filteredOrderDetail ? filteredOrderDetail.length : 0;

  return Math.max(Math.ceil(totalData / pageSize), 1);
};

const mapStateToProps = state => ({
  menuOpen: state.uiMenu.menuOpen,
  orders: getPageFilteredOrderDetails(state),
  selectedTab: state.uiOrderDetailVendor.selectedTab,
  filters: state.uiOrderDetailVendor.filters,
  activePage: state.uiOrderDetailVendor.activePage,
  pageSize: state.uiOrderDetailVendor.pageSize,
  totalPage: getTotalPage(state),
  sortField: state.uiOrderDetailVendor.sortField,
  sortDirection: state.uiOrderDetailVendor.sortDirection,
});

const mapDispatchToProps = dispatch => ({
  onChangeFilter: (filterName, value) => {
    dispatch(setOrderDetailVendorFilter(filterName, value));
  },
  onChangePaging: (pageField, value) => {
    dispatch(setOrderDetailVendorPaging(pageField, value));
  },
  onChangeSort: (sortField, sortDirection) => {
    dispatch(setOrderDetailVendorSort(sortField, sortDirection));
  },
  onTabPressed: (tappedTabIndex) => {
    dispatch(setOrderDetailVendorSelectedTab(tappedTabIndex));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetailVendorPage);
